import { z } from "zod";

export const OfferingCategory = z.enum(
    [
        "dining",
        "nightlife",
        "flight",
        "train",
        "accommodation",
        "travelItinerary",
        "transportation",
        "event",
        "localExperience",
        "shopping",
        "wellness",
        "services",
        "other",
    ],
    { error: () => "Primary category is required" },
);

export type OfferingCategory = z.infer<typeof OfferingCategory>;
